/*
 * Where the broker's answer leaves this link. Only CH Robinson reports counters
 * today; other boards' counters belong here when they arrive.
 *
 *   "initial"       no answer to act on, the carrier names a price
 *   "accepted"      the broker said yes, the carrier confirms
 *   "counter"       the broker countered and takes another offer
 *   "counter_final" the broker countered and the carrier can only take it
 */
export function offerState(booking) {
  const status = booking.chr_bidding_status;
  if (status === "accepted") return "accepted";
  if (status === "countered" && booking.chr_counter_price_cents != null) {
    // The counter response refuses a new number on a load that isn't editable.
    return booking.price_editable === false ? "counter_final" : "counter";
  }
  return "initial";
}

export function counterCents(booking) {
  return booking.chr_counter_price_cents ?? null;
}

// True once the broker has answered and the carrier owes a reply.
export function awaitingCarrier(booking) {
  return offerState(booking) !== "initial";
}
